import { Grid, Paper } from "@material-ui/core";
import { Box } from "@mui/material";
import { CustomPasswordInput } from "components/uiComponents/CustomPasswordInput";
import CustomTextField from "components/uiComponents/CustomTextField";
import FormikControl from "components/wrapperComponents/FormikControl";
import { msgTypes } from "constants/msgTypes";
import { RouteType } from "constants/RouteType";
import { useFormik } from "formik";
import { AuthModel } from "model/utilModels/AuthModel";
import { useRef, useState } from "react";
import RECAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from "react-router-dom";
import { loginSchema } from "schemas/menu/auth/loginSchema";
import { AuthService } from "services/auth/AuthService";
import { LocalStorageService } from "services/auth/LocalStorageService";
import { useAuth } from "util/auth";
import SlidingpanelForLoginAndForgotPassword from "../slidingPanelForLoginAndForgotPassword/SlidingpanelForLoginAndForgotPassword";
import "./Login.scss";

const Login = () => {
  const [captchaMatched, setCaptchaMatched] = useState(false);
  const [isToggled, setToggle] = useState(false);
  const recaptcha = useRef();
  const navigate = useNavigate();
  const auth = useAuth();


  const initialValues = {
    email: "",
    password: "",
  };

  const formikValue = useFormik({
    initialValues: initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, action) => {
      signIn(values);
      //action.resetForm();
    },
  });



  const { values, errors, touched, handleSubmit, isValid, dirty } = formikValue;

  const prepareRequestBody = (values) => {
    const requestData: AuthModel = new AuthModel();
    requestData.email = values.email;
    requestData.password = values.password;

    return requestData;
  };

  //Login with captcha
  async function signIn(values) {
    try {
      const requestBody = prepareRequestBody(values);
      const res = await AuthService.autanticateUser(requestBody);
      // console.log("user id is", res)
      if (res) {
        if (res.statusMsg === msgTypes.SUCCESS.msg) {
          LocalStorageService.setToken(res.data.authorization.token);
          const userRes = res.data.user;
          if (userRes) {

            LocalStorageService.setUserRole(userRes.role);
            localStorage.setItem('userId',userRes.userId)
            //auth.setUserRole(userRes.role);
            auth.login(userRes.firstName);
            if (res.data.member) {
              LocalStorageService.setUserDetails(
                JSON.stringify(res.data.member[0])
              );
            }
          }
          navigate(RouteType.HOME + RouteType.DASHBOARD);
        }
      }
    } catch (error) {
    }
  }

  const onCaptchaSubmit = (value) => {
    if (value) setCaptchaMatched(true);
    else setCaptchaMatched(false);
  };
  const handleToggle = () => {
    setToggle(!isToggled);
  };


  return (
    <>
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <Box className=" main-box flex max-w-3 main-box-sec">
                <Grid className="login-grid">
                  <Paper elevation={3} className="login-paper">
                    <div className="login-box p-4 ">
                      <div className="admin-logo-1">
                        <img
                          src="/images/1wn-logo.png"
                          alt="logo"
                        />
                      </div>
                      <h2>Sign In</h2>
                      <p >Enter User Id and password to sign in</p>
                      <form onSubmit={handleSubmit}>
                        <div className="row login-section-flow">
                          <div className="col-lg-12">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-lg-12">
                                  </div>
                                  <div className="col-lg-12 position-relative">
                                    <CustomTextField
                                      name="email"
                                      // requiredField
                                      disabled={false}
                                      placeholder={"Username"}
                                      value={values.email}
                                      error={errors.email}
                                      touched={touched.email}
                                      formikValue={formikValue}
                                      className='form-two'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-lg-12">

                                  </div>
                                  <div className="col-lg-12 position-relative">
                                    <CustomPasswordInput
                                      name="password"
                                      // requiredField
                                      disabled={false}
                                      placeholder={"Password"}
                                      value={values.password}
                                      error={errors.password}
                                      touched={touched.password}
                                      formikValue={formikValue}
                                      className='form-two'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <RECAPTCHA
                          sitekey={window.location.href.includes(msgTypes.LOCALHOST) ? msgTypes.GOOGLE_CAPTCHA_SITE_KEY_LOCAL : msgTypes.GOOGLE_CAPTCHA_SITE_KEY_PROD}
                          ref={recaptcha}
                          onChange={onCaptchaSubmit}
                          className='recap-1'
                        />
                        <div className="d-flex justify-content-end align-items-center mt-3">
                          <Link to="/forgetpassword" className="forgot-password">Forgot Password?</Link>
                        </div>
                        <Box pt={2}>
                          <FormikControl
                            control='button'
                            fullWidth={true}
                            label="Sign In"
                            className={!(!isValid || !captchaMatched) && "login-button"}
                            type="submit"
                            disabled={!isValid || !captchaMatched }
                          />

                        </Box>
                      </form>
                    </div>
                  </Paper>
                </Grid>
              </Box>
            </div>

           <SlidingpanelForLoginAndForgotPassword />
           
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;






